import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect } from 'react';
import { LazyImage } from '@ui/common/lazy-image.tsx';
import { BreadcrumbItem, Breadcrumbs, Divider } from '@heroui/react';
import { SubcategoryListItems } from '@ui/subcategory/subcategory-list';
import { useNavigate } from 'react-router-dom';
import { Home2 } from 'iconsax-react';

const ListDivider = () => (
  <div className="px-4">
    <Divider className="bg-[#F8F9FA]" />
  </div>
);

export const AboutPage = () => {
  const set = useNavbar();
  const navigate = useNavigate();

  useEffect(() => {
    set.about();
  }, []);
  return (
    <>
      <div className="hidden lg:flex flex-col container max-w-7xl mx-auto pb-24 pt-12">
        <Breadcrumbs>
          <BreadcrumbItem href="/">
            <Home2 size="24" color="#9CA5AC" />
          </BreadcrumbItem>
          <BreadcrumbItem color="primary">
            О приложении
          </BreadcrumbItem>
        </Breadcrumbs>

        <div className="mt-6">
          <h1 className="text-4xl text-[#222222] font-bold">
            О приложении
          </h1>
        </div>
      </div>

      <div className="flex flex-col gap-y-6 items-center lg:mx-auto justify-center py-8 container max-w-7xl">
        <div className="w-40">
          <LazyImage src="/logo.svg" />
        </div>
        <p className="text-sm text-[#60656C]">
          Версия приложения {__VERSION__}
        </p>
      </div>

      <div className="bg-[#F8F9FA] h-2 -mx-4" />

      <div className="-mx-4 lg:mx-auto lg:container lg:max-w-7xl">
        <SubcategoryListItems
          className="h-16"
          title="Политика конфиденциальности"
          onPress={() => navigate('/privacy-of-policy')}
        />

        <ListDivider />

        <SubcategoryListItems
          className="h-16"
          title="Правила пользования"
          onPress={() => navigate('/terms')}
        />
      </div>
    </>
  );
};
